export const defaultOrgName = 'self';
